import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const pocketbase = defineConnector({
  identifier: "pocketbase",
  name: "PocketBase",
  tagLine: "Backend in a single file",
  logo,
  protocol: "http",
  tags: ["engineering", "data"],
  defaultUrlPattern: ({ host }) =>
    host
      ? `https://${host.replace(/\./g, "\\.")}/.*`
      : "https://.*\\.pockethost\\.io/.*",
  auth: (app) =>
    headerAuth([{ name: "Authorization", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an admin token",
      items: [
        {
          kind: "markdown",
          content:
            "Authenticate with your PocketBase admin API at `/api/admins/auth-with-password` to get a token, or use a collection auth token.",
        },
      ],
    },
    {
      title: "Enter your instance URL",
      items: [
        {
          kind: "input",
          label: "PocketBase host",
          placeholder: "my-app.pockethost.io",
          required: true,
          target: { kind: "configuration", field: "host" },
        },
      ],
    },
    {
      title: "Copy and paste the token into the field below",
      items: [
        {
          kind: "input",
          label: "Auth token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ host }) => `https://${host}/api/health`,
  },
});
